import React from 'react';
import { CTAButton, OFFER_ANCHOR_ID } from './CTAButton';
import { pricing } from '../data/pricing';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-white scroll-mt-8" data-id="element-114" data-mp="19jf7hqyurira">
      <div className="max-w-3xl mx-auto text-center" data-id="element-115" data-mp="1eh78rble0h85">
        <h2 id={OFFER_ANCHOR_ID} className="text-3xl md:text-4xl font-black text-brand-text mb-14 scroll-mt-12 md:scroll-mt-20" data-id="element-116" data-mp="1j8yt34dy9qpu">
          Oferta Especial de Lanzamiento
        </h2>

        <div className="bg-white rounded-[2rem] border-2 border-brand-greenDark p-8 md:p-12 shadow-xl relative max-w-xl mx-auto" data-id="element-117" data-mp="1s9diofxy5rz5">
          <p className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-greenDark text-white px-6 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase whitespace-nowrap" data-id="element-118" data-mp="1xa1gbkgol72c">
            Contenido incluido
          </p>

          <dl className="space-y-4 mb-8 text-left" data-id="element-119" data-mp="2x1rd0qev0ie">
            {pricing.lineItems.map(item => <div key={item.label} className="flex justify-between items-center gap-6 border-b border-brand-creamDark pb-4" data-id="element-120" data-mp="1mgodf7m173ir">
                <dt className="text-brand-text font-medium" data-id="element-121" data-mp="1hon6m17mu504">{item.label}</dt>
                <dd className="text-brand-terracottaText font-medium line-through" data-id="element-122" data-mp="1crn1ptmir8al">
                  {item.price}
                </dd>
              </div>)}
            <div className="flex justify-between items-center gap-6 pt-2" data-id="element-123" data-mp="25g2avziyywe0">
              <dt className="font-bold text-brand-text uppercase text-sm tracking-wide" data-id="element-124" data-mp="20gfyttevnm6s">
                Valor total:
              </dt>
              <dd className="flex items-center gap-2" data-id="element-125" data-mp="1vgbh6028glez">
                <span className="font-bold text-brand-terracottaText line-through" data-id="element-126" data-mp="1vj7gnstqbi5j">
                  {pricing.fullValue}
                </span>
                <span className="bg-brand-terracottaSoft text-brand-terracottaText text-[11px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full" data-id="element-127" data-mp="k38zf1oedpt8">
                  {pricing.discountLabel}
                </span>
              </dd>
            </div>
          </dl>

          <div className="text-center mb-8" data-id="element-128" data-mp="mgkvtvzqj692">
            <p className="text-5xl md:text-6xl font-black text-brand-terracottaText tracking-tight mb-1" data-id="element-129" data-mp="mgcjc57iy2ye">
              {pricing.price}
            </p>
            <p className="text-sm font-bold uppercase tracking-widest text-brand-gray" data-id="element-130" data-mp="ciewnm5bce7w">
              {pricing.currencyNote}
            </p>
          </div>

          <CTAButton to="checkout" className="w-full mb-6 text-base md:text-lg py-5" data-id="element-131" data-mp="3uvd38bwm25b1" />

          <p className="text-xs text-brand-gray font-medium" data-id="element-132" data-mp="3jtjy7mivtf1">
            Descarga inmediata &middot; Pago seguro &middot; Acceso de por vida
            &middot; Sin suscripción
          </p>
        </div>
      </div>
    </section>;
}